export { createUrqlClient } from './createUrqlClient';
export { batchFetchExchange } from './batchFetchExchange';
